module.exports = "<button type=\"button\" class=\"btn btn-default tr-table-remove\" ng-click=\"vm.remove()\"><span class=\"ti-trash\"></span></button>";